export const tupleToKeyValue = <K, V>(tuple: [K, V]): { key: K; value: V } => {
  return {
    key: tuple[0],
    value: tuple[1],
  }
}
